import { connect } from 'react-redux';
import classnames from 'classnames';
import autobind from 'core-decorators/lib/autobind';

import { WixConnect } from 'shared/utils/wix-connect';
import memoizedPartial from 'shared/utils/memoized-partial';

import { areElementsRounded } from 'shared/selectors/app-settings';

import Button from './button';

import styles from './buttons-group.styl';


@connect(state => ({
  isRounded: areElementsRounded(state),
}))
@WixConnect(styles)
export default class ButtonsGroup extends React.Component {

  static propTypes = {
    buttons: React.PropTypes.arrayOf(React.PropTypes.shape({
      label: React.PropTypes.any,
      key: React.PropTypes.string,
    })),
    disableTheme: React.PropTypes.bool,
    defaultActive: React.PropTypes.string,
    onChange: React.PropTypes.func,
    isRounded: React.PropTypes.bool,
    className: React.PropTypes.string,
  };

  static defaultProps = {
    onChange: _.noop,
    disableTheme: false,
  };

  state = {
    currentActive: null,
  };

  componentWillMount() {
    const { buttons } = this.props;
    let { defaultActive } = this.props;

    if (!buttons.length) {
      return;
    }

    if (!defaultActive) {
      defaultActive = _.get(buttons, '[0].key');
    }

    this.handleClick(defaultActive);
  }

  @autobind
  handleClick(key) {
    const { currentActive } = this.state;
    const { onChange } = this.props;

    if (currentActive !== key) {
      this.setState({
        currentActive: key,
      });

      onChange(key);
    }
  }

  get buttonList() {
    const { buttons, disableTheme } = this.props;
    const { currentActive } = this.state;

    return _.map(buttons, button => {
      if (!button) {
        return null;
      }

      const { key, label, className } = button;
      const active = key === currentActive;
      const styleNames = classnames('button', {
        'disable-theme': disableTheme,
        active,
      });

      return (
        <Button styleName={styleNames}
                key={key}
                onClick={memoizedPartial(this.handleClick, key)}
                className={className}>
          {label}
        </Button>
      );
    });
  }

  render() {
    const { isRounded, buttons, className } = this.props;

    if (!buttons.length) {
      return null;
    }

    const styleNames = classnames('buttons-wrapper', {
      rounded: isRounded,
    });

    return (
      <div styleName={styleNames}
           className={className}>
        {this.buttonList}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/button/buttons-group.js